(function () {
  if (window.__shareRestorationTrackingLoaded) return;
  window.__shareRestorationTrackingLoaded = true;

  var PHONE_CLICK_FALLBACK_DELAY = 350;
  var PHONE_CLICK_MATCH_WINDOW = 900;
  var observedPhoneClicks = [];

  window.dataLayer = window.dataLayer || [];

  function normalizePhone(value) {
    var digits = String(value || '').replace(/^tel:/i, '').replace(/\D/g, '');

    if (digits.length === 10) {
      return '+1' + digits;
    }

    if (digits.length === 11 && digits.charAt(0) === '1') {
      return '+' + digits;
    }

    return digits ? '+' + digits : '';
  }

  function getText(element) {
    return String((element && (element.innerText || element.textContent)) || '')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, 160);
  }

  function getSectionName(element) {
    var section = element.closest('[data-section-type], section, header, footer, nav, .shopify-section');

    if (!section) return '';
    if (section.id) return section.id;
    if (section.getAttribute('data-section-type')) return section.getAttribute('data-section-type');
    if (section.className && typeof section.className === 'string') {
      return section.className.replace(/\s+/g, ' ').trim().slice(0, 120);
    }

    return section.tagName ? section.tagName.toLowerCase() : '';
  }

  function getBasePayload(element, eventType) {
    var href = element.href || element.getAttribute('href') || '';
    var idElement = element.id ? element : element.closest('[id]');

    return {
      event_category: 'engagement',
      event_action: eventType,
      click_text: getText(element),
      click_url: href,
      link_url: href,
      page_location: window.location.href,
      page_path: window.location.pathname,
      page_title: document.title,
      click_section: getSectionName(element),
      click_id: (idElement && idElement.id) || '',
      click_classes: String(element.className || '').replace(/\s+/g, ' ').trim().slice(0, 160)
    };
  }

  function getGtagParams(payload) {
    var params = {};
    var allowedKeys = [
      'event_category',
      'event_action',
      'click_text',
      'click_url',
      'link_url',
      'page_location',
      'page_path',
      'page_title',
      'click_section',
      'click_id',
      'click_classes',
      'phone_number',
      'phone_digits',
      'phone_area_code',
      'email_link',
      'link_type',
      'form_id',
      'form_name',
      'form_action',
      'form_method'
    ];

    allowedKeys.forEach(function (key) {
      if (payload[key] !== undefined && payload[key] !== null && payload[key] !== '') {
        params[key] = payload[key];
      }
    });

    return params;
  }

  function pushGtagEvent(payload) {
    if (!payload || !payload.event || payload.event.indexOf('share_') !== 0) return;
    if (typeof window.gtag !== 'function') return;

    window.gtag('event', payload.event, getGtagParams(payload));
  }

  function pushDataLayer(payload) {
    window.dataLayer.push(payload);
    pushGtagEvent(payload);
  }

  function observePhoneClickFromDataLayer(item) {
    if (!item || item.event !== 'gtm.click') return;

    var elementUrl = item['gtm.elementUrl'] || item.click_url || '';
    if (!String(elementUrl).toLowerCase().startsWith('tel:')) return;

    observedPhoneClicks.push({
      phone: normalizePhone(elementUrl),
      url: elementUrl,
      at: Date.now()
    });

    observedPhoneClicks = observedPhoneClicks.slice(-30);
  }

  function wrapDataLayerPush() {
    if (window.dataLayer.__shareRestorationWrapped) return;

    var originalPush = window.dataLayer.push.bind(window.dataLayer);

    window.dataLayer.push = function () {
      Array.prototype.forEach.call(arguments, observePhoneClickFromDataLayer);
      return originalPush.apply(window.dataLayer, arguments);
    };

    window.dataLayer.__shareRestorationWrapped = true;
    window.dataLayer.forEach(observePhoneClickFromDataLayer);
  }

  function sawNativePhoneClick(phone, clickTime) {
    return observedPhoneClicks.some(function (item) {
      return item.phone === phone && item.at >= clickTime - 50 && item.at <= clickTime + PHONE_CLICK_MATCH_WINDOW;
    });
  }

  function pushSyntheticGtmClick(link, payload, clickTime) {
    var phone = payload.phone_number;

    window.setTimeout(function () {
      if (sawNativePhoneClick(phone, clickTime)) return;

      pushDataLayer({
        event: 'gtm.click',
        'gtm.element': link,
        'gtm.elementUrl': link.href || link.getAttribute('href') || '',
        'gtm.elementText': payload.click_text,
        share_restoration_synthetic: true,
        share_tracking_source: 'share-restoration-tracking'
      });
    }, PHONE_CLICK_FALLBACK_DELAY);
  }

  function handlePhoneClick(link) {
    var clickTime = Date.now();
    var payload = getBasePayload(link, 'phone_click');
    var phoneNumber = normalizePhone(payload.click_url);

    payload.event = 'share_phone_click';
    payload.phone_number = phoneNumber;
    payload.phone_digits = phoneNumber.replace(/\D/g, '');
    payload.phone_area_code = payload.phone_digits.length >= 10 ? payload.phone_digits.slice(-10, -7) : '';

    pushDataLayer(payload);
    pushSyntheticGtmClick(link, payload, clickTime);
  }

  function handleEmailClick(link) {
    var payload = getBasePayload(link, 'email_click');

    payload.event = 'share_email_click';
    payload.email_link = payload.click_url.replace(/^mailto:/i, '').split('?')[0];

    pushDataLayer(payload);
  }

  function handleGenericClick(element) {
    var payload = getBasePayload(element, 'click');

    payload.event = 'share_click';
    payload.link_type = element.tagName && element.tagName.toLowerCase() === 'button' ? 'button' : 'link';

    pushDataLayer(payload);
  }

  function handleClick(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var link = target.closest('a[href]');
    if (link) {
      var href = String(link.getAttribute('href') || '');

      if (href.toLowerCase().startsWith('tel:')) {
        handlePhoneClick(link);
        return;
      }

      if (href.toLowerCase().startsWith('mailto:')) {
        handleEmailClick(link);
        return;
      }

      handleGenericClick(link);
      return;
    }

    var button = target.closest('button, [role="button"], input[type="submit"], input[type="button"]');
    if (button) handleGenericClick(button);
  }

  function handleSubmit(event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form')) return;

    var payload = getBasePayload(form, 'form_submit');

    payload.event = 'share_form_submit';
    payload.form_id = form.id || '';
    payload.form_name = form.getAttribute('name') || '';
    payload.form_action = form.action || '';
    payload.form_method = form.method || '';

    pushDataLayer(payload);
    pushDataLayer({
      event: 'form_submit',
      share_event_alias: 'share_form_submit',
      form_id: payload.form_id,
      form_name: payload.form_name,
      form_action: payload.form_action,
      form_method: payload.form_method,
      page_location: payload.page_location,
      page_path: payload.page_path,
      page_title: payload.page_title
    });
  }

  wrapDataLayerPush();
  document.addEventListener('click', handleClick, true);
  document.addEventListener('submit', handleSubmit, true);

  window.ShareRestorationTracking = {
    normalizePhone: normalizePhone
  };
})();
